import { render, staticRenderFns } from "./StatisticBOMContainer.vue?vue&type=template&id=edc0feb4&scoped=true&"
import script from "./StatisticBOMContainer.vue?vue&type=script&lang=ts&"
export * from "./StatisticBOMContainer.vue?vue&type=script&lang=ts&"
import style0 from "./StatisticBOMContainer.vue?vue&type=style&index=0&id=edc0feb4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edc0feb4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VImg,VProgressCircular,VRow})
